export default __webpack_public_path__ + "static/media/dark17.3c798c24.png";